export default __webpack_public_path__ + "static/media/helpaccountdetails.0dbba03b.svg";